<template>
  <div class="sidebar-register">
    <div class="side-widget account-info" :class="{open: accountInfoOpen}">
      <h5 class="h6">
        Account Information
        <span class="toggle" @click="accountInfoOpen = !accountInfoOpen"></span>
      </h5>
      <div class="widget-content" v-if="accountInfoOpen">
        <table>
          <tbody>
            <tr>
              <td v-if="user.firstName && user.lastName">
                <span class="side-label">Name</span>
                <p>{{user.firstName}} {{user.lastName}}</p>
              </td>
            </tr>
            <tr>
              <td>
                <span class="side-label">Customer ID</span>
                <p>2872363</p>
              </td>
            </tr>
            <tr v-if="user.email">
              <td colspan="2">
                <span class="side-label">Email</span>
                <p>{{ user.email }}</p>
              </td>
            </tr>
            <tr v-if="user.phone">
              <td colspan="2">
                <span class="side-label">Phone</span>
                <p>{{ user.phone }}</p>
              </td>
            </tr>
            <tr v-if="company.name">
              <td colspan="2">
                <span class="side-label">Company Name</span>
                <p>{{ company.name }}</p>
              </td>
            </tr>
            <tr v-if="company.shopUrl || company.ShopType">
              <td v-if="company.shopUrl">
                <span class="side-label">Shop URL</span>
                <p>{{ company.shopUrl }}</p>
              </td>
              <td class="text-center" v-if="company.shopType">
                <img style :src="`img/shop-logos/${company.ShopType}.png`" alt="Shop logo" />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="side-widget service-config" :class="{open: serviceConfigOpen}" v-if="configsSelected">
      <h5 class="h6">
        Solution Configuration
        <span class="toggle" @click="serviceConfigOpen = !serviceConfigOpen"></span>
      </h5>
      <div class="widget-content" v-if="serviceConfigOpen">
        <div class="sidebar-summary pt-10 pb-10 d-flex">
          <strong class="flex-grow-1">Payment acceptance</strong>
          <span>
            <animated-number :value="paymentsTotal" :formatValue="formatToPrice" :duration="300" />
          </span>
        </div>
        <div class="sidebar-summary pt-10 pb-10 d-flex">
          <strong class="flex-grow-1">Services</strong>
          <span>
            <animated-number :value="servicesTotal" :formatValue="formatToPrice" :duration="300" />
          </span>
        </div>
      </div>
    </div>

    <div class="video-tutorial mt-20">
      <h5 class="h6">Video tutorial</h5>
      <div class="tutorial-thumb">
        <i class="uil uil-play"></i>
        <strong>Play now!</strong>
        <img src="@/assets/tutorial-thumbnail.png" alt="video-tutorial" style="width: 220px;" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapFields } from 'vuex-map-fields'
import smoothReflow from 'vue-smooth-reflow'
import AnimatedNumber from 'animated-number-vue'

export default {
  name: 'sidebar-register',
  mixins: [smoothReflow],
  components: {
    AnimatedNumber
  },
  computed: {
    ...mapFields({
      user: 'user',
      company: 'company',
      paymentAcceptance: 'paymentAcceptance',
      services: 'services'
    }),
    configsSelected() {
      const merged = [].concat(this.paymentAcceptance, this.services)
      return merged.filter(el => el.selected).length
    },
    paymentsTotal() {
      let total = 0
      this.paymentAcceptance
        .filter(el => el.selected)
        .forEach(el => {
          total += el.price
        })
      return total
    },
    servicesTotal() {
      let total = 0
      this.services
        .filter(el => el.selected)
        .forEach(el => {
          total += el.price
        })
      return total
    }
  },
  data() {
    return {
      accountInfoOpen: true,
      serviceConfigOpen: true
    }
  },
  mounted() {
    this.$smoothReflow({
      el: '.account-info'
    })

    this.$smoothReflow({
      el: '.service-config'
    })
  },
  methods: {
    formatToPrice(value) {
      return `€ ${value.toFixed(2)}`
    }
  }
}
</script>
